import {SchoolSubjectType} from "./subjectTypes";

export const DEFAULT_GRADE_TYPES = [
    {id: 1, name: "I"},
    {id: 2, name: "II"},
    {id: 3, name: "III"},
    {id: 4, name: "IV"},
    {id: 5, name: "V"},
    {id: 6, name: "VI"},
    {id: 7, name: "VII"},
    {id: 8, name: "VIII"},
    {id: 9, name: "IX"},
    {id: 10, name: "X"},
    {id: 11, name: "XI"},
    {id: 12, name: "XII"}
];

const SCHOOL_GRADE_TYPES: Record<SchoolSubjectType, {id: number, name: string}[]> = {
    2: [{id: 1, name: "I"}, {id: 2, name: "II"}],
    4: [
        {id: 3, name: "III"},
        {id: 4, name: "IV"},
        {id: 5, name: "V"},
        {id: 6, name: "VI"},
        {id: 7, name: "VII"},
        {id: 8, name: "VIII"},
        {id: 27, name: "IX"},
        {id: 28, name: "X"},
        {id: 29, name: "XI"},
        {id: 30, name: "XII"}
    ],
    3: [{id: 1, name: "I"}, {id: 2, name: "II"}],
    1: [
        {id: 3, name: "III"},
        {id: 4, name: "IV"},
        {id: 5, name: "V"},
        {id: 6, name: "VI"},
        {id: 7, name: "VII"},
        {id: 8, name: "VIII"},
        {id: 9, name: "IX"},
        {id: 10, name: "X"},
        {id: 11, name: "XI"},
        {id: 12, name: "XII"}
    ],
    22: [
        {id: 4, name: "IV"},
        {id: 5, name: "V"},
        {id: 6, name: "VI"},
        {id: 7, name: "VII"},
        {id: 8, name: "VIII"},
        {id: 54, name: "IX"},
        {id: 55, name: "X"},
        {id: 56, name: "XI"},
        {id: 57, name: "XII"}
    ],
    37: [
        {id: 4, name: "IV"},
        {id: 5, name: "V"},
        {id: 6, name: "VI"},
        {id: 7, name: "VII"},
        {id: 8, name: "VIII"},
        {id: 167, name: "IX"},
        {id: 168, name: "X"},
        {id: 169, name: "XI"},
        {id: 195, name: "XII"}
    ],
    33: [
        {id: 5, name: "V"},
        {id: 6, name: "VI"},
        {id: 7, name: "VII"},
        {id: 8, name: "VIII"},
        {id: 140, name: "IX"},
        {id: 141, name: "X"},
        {id: 142, name: "XI"},
        {id: 193, name: "XII"}
    ],
    34: [
        {id: 7, name: "VII"},
        {id: 8, name: "VIII"},
        {id: 152, name: "IX"},
        {id: 153, name: "X"},
        {id: 154, name: "XI"},
        {id: 196, name: "XII"}
    ],
    30: [
        {id: 6, name: "VI"},
        {id: 7, name: "VII"},
        {id: 8, name: "VIII"},
        {id: 126, name: "IX"},
        {id: 127, name: "X"},
        {id: 128, name: "XI"},
        {id: 194, name: "XII"}
    ],
};

export const getSchoolGradeTypes = (grade: number) => SCHOOL_GRADE_TYPES[grade as SchoolSubjectType];